<template>
  <div class="lab_wrapper">
    <div class="title">
      코드 테스트
      <div class="desc">서비스에 적용할만한 코드들을 구현, 테스트</div>
    </div>
    <b-container>
      <b-row>
        <b-col>
          <b-list-group>
            <b-list-group-item
              href="#"
              @click.prevent="editorwithupload"
              class="flex-column align-items-start"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">에디터 이미지 업로드</h5>
                <small>개발</small>
              </div>

              <p class="mb-1">TipTap 에디터에 이미지를 업로드하여 배치함.</p>

              <small>작업중</small>
            </b-list-group-item>

            <b-list-group-item href="#" class="flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">youtube에서 mp3 추출기능</h5>
                <small>개발</small>
              </div>

              <p class="mb-1">
                youtube 링크를 mp3 파일로 변환하여 S3에 업로드 하는기능
              </p>

              <small>시작전</small>
            </b-list-group-item>
            <b-list-group-item
              href="#"
              @click.prevent="print()"
              class="flex-column align-items-start"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">인쇄 레이아웃</h5>
                <small>개발</small>
              </div>

              <p class="mb-1">시험 조판시 페이지별 page-break 체크</p>

              <small>작업중</small>
            </b-list-group-item>

            <b-list-group-item
              href="#"
              @click.prevent="print()"
              class="flex-column align-items-start"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">시험문항 이미지를 통한 문항 타입 구별</h5>
                <small>ML</small>
              </div>

              <p class="mb-1">
                사진으로 캡쳐한 시험지 이미지를 분석하여 문항타입(14종) 구분
              </p>

              <small>작업중</small>
            </b-list-group-item>
            <b-list-group-item
              href="#"
              @click.prevent="swiper()"
              class="flex-column align-items-start"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">SWIPPER</h5>
                <small>개발</small>
              </div>

              <p class="mb-1">스와이프 기반 학습 UX</p>

              <small>작업중</small>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  methods: {
    editorwithupload() {
      this.$router.push("/admin/labs/imageeditor");
    },

    print() {
      this.$router.push("/admin/labs/print");
    },
    swiper() {
      this.$router.push("/admin/labs/swipper");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.title {
  font-size: 1.5em;
  color: $gray500;
  margin-bottom: 15px;
  .desc {
    font-size: 0.7em;
  }
}
.lab_wrapper {
  margin: 15px;
}
</style>